import axios, { isAxiosError } from 'axios'
import axiosRetry from 'axios-retry'
import router from './router'
import { mutations } from './store'

// https://github.com/softonic/axios-retry/issues/87
const retryDelay = (retryNumber = 0) => {
  const seconds = Math.pow(2, retryNumber) * 1000
  const randomMs = 1000 * Math.random()
  return seconds + randomMs
}

const client = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true, // send cookies with requests
  withXSRFToken: true    // send XSRF token with requests
})

// Refresh code was adapted from ChatGPT code
// Flag to avoid multiple refresh attempts
let isRefreshing = false;
let subscribers = [];

function addSubscriber(callback) {
  subscribers.push(callback);
}

function onAccessTokenFetched() {
  subscribers.forEach((callback) => callback());
  subscribers = [];
}

function signOut() {
  if (router.currentRoute.name !== "SignIn") {
    mutations.signOut()
    router.push({ name: 'SignIn' })
  }
}

// Add a response interceptor for authentication failures
client.interceptors.response.use(function (response) {
  console.log("Intercepted - Response:")
  console.log(response);
  return response;
}, async function (error) {
  console.log("Intercepted - Error:" + error)
  const originalRequest = error.config;

  // If 401 and not retrying
  if (isAxiosError(error) && error.response.status === 401 && !originalRequest._retry) {
    if (isRefreshing) {
      return new Promise(resolve => {
        addSubscriber(() => resolve(client(originalRequest)));
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      await axios.post('/admin/v1/auth/refresh', null, {
        withCredentials: true,
      });

      isRefreshing = false;
      onAccessTokenFetched();

      return client(originalRequest);
    } catch (err) {
      isRefreshing = false;
      signOut();
      return Promise.reject(err);
    }
  }

  if (error.response && error.response.status === 403) {
    signOut();
  }
  return Promise.reject(error)
})

axiosRetry(client, {
  retries: 2,
  retryDelay,
  // retry on Network Error & 5xx responses
  retryCondition: axiosRetry.isRetryableError
})

export default client
